import FormView from "@/components/form/FormView"
import { store } from "@/stores/stores"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { useSnapshot } from "valtio"
import { z } from "zod"

function ConfirmModal() {
  const snap = useSnapshot(store)

  const form = useForm({
    resolver: zodResolver(z.object({})),
  })

  return (
    <FormView
      opened={!!snap.app.confirmModal?.opened}
      form={form}
      title={snap.app.confirmModal?.title}
      onSubmit={() => {
        return snap.app.confirmModal?.onConfirm()!
      }}
      onClose={() => {
        // store.app.confirmModal!.opened = false
        store.app.confirmModal = null
      }}
      // onExitTransitionEnd={() => {
      // }}
      confirmButtonProps={{
        children: "Continue",
        ...(snap.app.confirmModal?.danger ? { color: "red" } : {}),
      }}
      destroyOnClose
    >
      {snap.app.confirmModal?.children as any}
    </FormView>
  )
}

export default ConfirmModal
